import { UnionMap, UnionValueMap } from '../../../../types/union-map';
import { MockScenarioConfiguration } from '../../../types';
import getRegionRecommendationsFail from './get-region-recommendations-fail.json';
import getRegionRecommendations from './get-region-recommendations.json';

export type DiscoveryServiceRegionRecommendationScenarioName =
    | 'GetRegionRecommendations'
    | 'GetRegionRecommendationsFail';

export const DiscoveryServiceRegionRecommendationScenarioName: UnionMap<DiscoveryServiceRegionRecommendationScenarioName> =
    {
        GetRegionRecommendations: 'GetRegionRecommendations',
        GetRegionRecommendationsFail: 'GetRegionRecommendationsFail',
    };

export const DiscoveryServiceRegionRecommendationScenarios: UnionValueMap<
    DiscoveryServiceRegionRecommendationScenarioName,
    MockScenarioConfiguration
> = {
    GetRegionRecommendations: getRegionRecommendations as MockScenarioConfiguration,
    GetRegionRecommendationsFail: getRegionRecommendationsFail as MockScenarioConfiguration,
};
